import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {getSummaryTicketName, getSummaryTicketPriceFromReservation} from '../../../../selectors/placed-order'
import {SummaryRow} from '../summary-row'
import {TicketProps} from './interfaces'
import {classes} from './ticket.st.css'

export const Ticket = ({ticket, ticketDetails, quantity}: TicketProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()

  const resolvedQuantity = ticketDetails?.capacity ?? quantity
  const {labeledPrice, total} = getSummaryTicketPriceFromReservation(
    ticket,
    t,
    getFormattedMoney,
    resolvedQuantity,
    ticketDetails,
  )

  const getTicketAriaLabel = () => {
    const name = `${t('ticketsThankYou.ticketName')}: ${ticket.name}`
    const qty = t('mobile.thanks.quantity', {quantity: resolvedQuantity})
    return `${name}, ${labeledPrice}, ${qty}`
  }

  return (
    <div data-hook={DH.TICKET} className={classes.container} role="group" aria-label={getTicketAriaLabel()}>
      <SummaryRow label={getSummaryTicketName(ticket, ticketDetails)} value={total} />
      <Text className={classes.quantity} data-hook={DH.TICKET_QUANTITY}>
        {t('mobile.thanks.quantity', {quantity: resolvedQuantity})}
      </Text>
    </div>
  )
}
